module.exports = __webpack_public_path__ + "img/infographics_7.c736aa43.png";